export default import.meta.ROLLDOWN_FILE_URL_MltoNlJ0wXB11jxBULJk7w